




<template>
    <v-app>
        <template>
            <v-navigation-drawer class="custom-nav" v-model="drawer" app height="fit-content">
                <v-list dense>
                    <v-list-item class="custom-item">
                        <v-list-item-action>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <a :href="rutaInicio">
                                <v-list-item-title>Inicio</v-list-item-title>
                            </a>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group prepend-icon="">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Descubre</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-map</v-icon>
                            </v-list-item-action>
                            <a :href="rutaLugares">
                                <v-list-item-title>Lugares</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-map</v-icon>
                            </v-list-item-action>
                            <a :href="rutaMapaInt">
                                <v-list-item-title>Mapa</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-star</v-icon>
                            </v-list-item-action>
                            <a :href="rutaPdi">
                                <v-list-item-title>Puntos de Interés</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-map</v-icon>
                            </v-list-item-action>
                            <a :href="rutaRutas">
                                <v-list-item-title>Rutas</v-list-item-title>
                            </a>
                        </v-list-item>
                    </v-list-group>

                    <v-list-group prepend-icon="">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Disfruta</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-walk</v-icon>
                            </v-list-item-action>
                            <a :href="rutaCallejeros">
                                <v-list-item-title>Callejeros</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-help</v-icon>
                            </v-list-item-action>
                            <a :href="rutaCuriosidades">
                                <v-list-item-title>Curiosidades</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-download</v-icon>
                            </v-list-item-action>
                            <a :href="rutaDescargaInformacion">
                                <v-list-item-title>Descarga Información</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-link</v-icon>
                            </v-list-item-action>
                            <a :href="rutaEnlacesInteres">
                                <v-list-item-title>Enlaces de interés</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-calendar</v-icon>
                            </v-list-item-action>
                            <a :href="rutaEventos">
                                <v-list-item-title>Eventos</v-list-item-title>
                            </a>
                        </v-list-item>
                    </v-list-group>
                    <v-list-group prepend-icon="">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Planifica</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-information</v-icon>
                            </v-list-item-action>
                            <a :href="rutaOficina">
                                <v-list-item-title>Oficina de turismo</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-map</v-icon>
                            </v-list-item-action>
                            <a :href="rutaMapaInt">
                                <v-list-item-title>Mapa</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-bed</v-icon>
                            </v-list-item-action>
                            <a :href="rutaDormir">
                                <v-list-item-title>Dónde dormir</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-food</v-icon>
                            </v-list-item-action>
                            <a :href="rutaComer">
                                <v-list-item-title>Dónde comer</v-list-item-title>
                            </a>
                        </v-list-item>
                        <v-list-item class="custom-item">
                            <v-list-item-action>
                                <v-icon>mdi-hiking</v-icon>
                            </v-list-item-action>
                            <a :href="rutaActividades">
                                <v-list-item-title>Actividades</v-list-item-title>
                            </a>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item class="custom-item">
                        <v-list-item-action>
                            <v-icon>mdi-open-in-new</v-icon>
                        </v-list-item-action>
                        <a :href="rutaOpendata">
                                <v-list-item-title>Opendata</v-list-item-title>
                            </a>
                    </v-list-item>

                    <v-list-item class="custom-item">
                        <v-list-item-action>
                            <v-icon>mdi-wheelchair-accessibility</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <a :href="turismoaccesible">
                                <v-list-item-title>Turismo Accesible</v-list-item-title>
                            </a>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="custom-item" @click="buscadorToolbar = !buscadorToolbar">
                        <v-list-item-action>
                            <v-icon>mdi-magnify</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <div class="scrollable-search">
                                <Search class="buscadorMovil"></Search>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>

            <v-app-bar app class="custom-app-bar" :color="'#d6e0a8'">
                <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>Castropol Turismo</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-app-bar>
        </template>
    </v-app>
</template>
  
<script>
import Search from "./Search.vue";

export default {
    components: {
        Search,
    },
    data: () => ({
        drawer: null,
        buscadorToolbar: false,
        // Ruta Inicio
        rutaInicio: "/inicio",
        // Rutas Descubre
        rutaLugares: "/lugares",
        rutaMapaInt: "/mapa",
        rutaNoticia: "/noticias",
        rutaPdi: "/pdi",
        rutaRutas: "/rutas",

        // Rutas Disfruta
        rutaCallejeros: "/callejeros",
        rutaOpendata: "/tarjeta",
        rutaCuriosidades: "/curiosidades",
        rutaDescargaInformacion: "/descarga",
        rutaEnlacesInteres: "/enlaces",
        rutaEventos: "/eventos",

        // Rutas Planifica
        rutaOficina: "/oficina",
        rutaMapaInt: "/mapa",
        rutaDormir: "/dormir",
        rutaComer: "/comer",
        rutaActividades: "/actividades",

        // Ruta Turismo Accesible
        turismoaccesible: "/turismo-accesible",
    })
};

</script>
  
<style scoped>
.custom-item:hover {
    background-color: #d6e0a8;
}

.custom-app-bar {
    width: 95% !important;
}

.custom-nav {
    width: 90% !important;
}
.scrollable-search {
  max-height: 300px;
  overflow-y: auto;
}
</style>
  